import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { InventoryTransactionTypeEntity } from './inventory-transaction-type.model';

@Injectable({
    providedIn: 'root'
})
export class InventoryTransactionTypeService {
    private httpClient = inject(HttpClient);

    getInventoryTransactionTypes(subscriberKey: number) {
        return this.httpClient.get<InventoryTransactionTypeEntity[]>(`api/subscriber/${subscriberKey}/inventory-transaction-types`);
    }
}
